import { render, staticRenderFns } from "./newSpeakerEdition.vue?vue&type=template&id=037ff42e"
import script from "./newSpeakerEdition.vue?vue&type=script&lang=js"
export * from "./newSpeakerEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports